module.exports = __webpack_public_path__ + "static/media/TwitterLogo_black.251fc8d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TwitterLogo_black.svg
// module id = 950
// module chunks = 0